import { render, staticRenderFns } from "./PdfReview.vue?vue&type=template&id=0d0acebc&scoped=true"
import script from "./PdfReview.vue?vue&type=script&lang=js"
export * from "./PdfReview.vue?vue&type=script&lang=js"
import style0 from "./PdfReview.vue?vue&type=style&index=0&id=0d0acebc&prod&lang=scss&scoped=true"
import style1 from "./PdfReview.vue?vue&type=style&index=1&id=0d0acebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0acebc",
  null
  
)

export default component.exports